// actionTypes.js
export const SET_VALUE_ModeleSouscription = "SET_VALUE_ModeleSouscription";
export const SET_TYPE_ModeleSouscription = "SET_TYPE_ModeleSouscription";
export const SET_CURRENT_PAGE_ModeleSouscription =
  "SET_CURRENT_PAGE_ModeleSouscription";
export const SET_ORDER_ModeleSouscription = "SET_ORDER_ModeleSouscription";
export const SET_SORT_FIELD_ModeleSouscription =
  "SET_SORT_FIELD_ModeleSouscription";
export const SET_ACTIF_ModeleSouscription = "SET_ACTIF_ModeleSouscription";
export const SET_CATEGORIE_ModeleSouscription =
  "SET_CATEGORIE_ModeleSouscription";
